<template>
    <div></div>
</template>

<script>
import MDRouter from "@/service/router"
import domain from '@/service/domain'
import { getPCMessageList,setPCMessageRead  } from "@/api/index";
let notificationInstance = null;
export default {
    props: ["show"],
    mounted(){

        this.showNotify()

        


    },

    unmounted() {

    },


    methods: {
        goQestion() {
            window.open('https://zhongchou.modian.com/about/index/2/1.html?_mpos=h_foot_aboutus')
        },
        goReply() {
            window.open('https://zhongchou.modian.com/helpcenter/reply?_ga=2.80450007.19177274.1666930957-1226901126.1666159598')
        },
        goHelpCenter() {
            MDRouter.goServeCenter()
        },
        async showNotify() {
     
            const {status, data} = await getPCMessageList({
                'is_read': 0,
                'type': -1,
                'page': 1,
                'page_size': 10
            })

            if (status == 0) {
                //只有请求成功&&未读数大于0

                if(notificationInstance) {
                    notificationInstance.close()
                }
                if (data && data.list && data.list.length) {
                    const unread_messge = data.list[0]

                    notificationInstance = this.$notify({
                        title: `${unread_messge.title}`,
                        message: `<div style="max-width=100%;">${unread_messge.content}<div style="margin-top: 10px; text-align: right;">
                            <button id="customButton1" style="background-color: #FFFFFF; color: #A1A1A1; border: 1px solid #F2F2F2; padding: 5px 10px; border-radius: 4px; cursor: pointer;">
                            设为已读
                            </button>
                            <button id="customButton2" style="background-color: #00C4A1; color: white; border: none; padding: 5px 10px; border-radius: 4px; cursor: pointer;margin-left:5px;">
                            查看全部
                            </button>
                        </div></div>`,
                        dangerouslyUseHTMLString: true,
                        duration: 0,
                        offset:60,
                        customClass: 'custom-notification' // 自定义类名

                    });

                    setTimeout(() => {
                        let that = this;
                        // 绑定点击事件
                        document.getElementById('customButton1').onclick = async function () {
                            // 自定义逻辑，比如跳转或发送请求
                            console.log('设为已读')

                            const {status, data} = await setPCMessageRead({
                                'message_id': unread_messge.id,
                            })

                            if(status == 0 && data && data.is_read_success) {

                                // 成功设置为已读-关闭弹窗
                                //notificationInstance.close()

                                that.showNotify()
                            }

                        };

                            // 绑定点击事件
                            document.getElementById('customButton2').onclick = function() {
                                // 自定义逻辑，比如跳转或发送请求
                                console.log('查看全部')

                                window.open(`${domain.www}/message/list`)
                                notificationInstance.close()
                                };
                    },500)
                } 
            }
        }
    }
}
</script>

<style lang="scss" >
 .custom-notification {
    .el-notification__group {
        width: 100%;
    }
 }
</style>